import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { AppsService } from "src/app/shared/services/apps.service";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import moment from "moment";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_frozen from "@amcharts/amcharts4/themes/frozen";

am4core.useTheme(am4themes_frozen);
am4core.useTheme(am4themes_animated);

@Component({
  selector: "app-state-fuel-dashboard",
  templateUrl: "./state-fuel-dashboard.component.html",
  styleUrls: ["./state-fuel-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StateFuelDashboardComponent implements OnInit, OnDestroy {
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridTotals0: any[] = [
    {
      column: "tnt_dsply_nm",
      summaryType: "count",
      displayFormat: "Total: {0}",
    },
    { column: "total_entries", summaryType: "sum", displayFormat: "{0}" },
    { column: "ptrl_lt", summaryType: "sum", displayFormat: "{0}" },
    { column: "dsl_lt", summaryType: "sum", displayFormat: "{0}" },
    { column: "cng_lt", summaryType: "sum", displayFormat: "{0}" },
    { column: "total_lt", summaryType: "sum", displayFormat: "{0}" },
    { column: "total_am", summaryType: "sum", displayFormat: "{0}" },
    { column: "vehicles_ct", summaryType: "sum", displayFormat: "{0}" },
  ];

  header_label = {
    name: "State Fuel Dashboard",
  };

  showLdr = false;
  filters: boolean = true;
  fromUrbanDashboard: boolean = false;
  clntDtls: any;
  tntLst: any = [];
  selectedtenant = 0;
  userDtls: any;
  slctdDt: any;
  curMonth: number;
  curYear: number;

  // Summary data
  fuelSummary: any = null;
  mileageVarianceCount: number = 0;

  // ULB fuel entered/not entered
  ulbsFuelEntered: number = 0;
  ulbsFuelNotEntered: number = 0;
  totalUlbs: number = 0;
  selectedUlbCard: string = "";

  // Chart data
  last7DaysData: any = [];
  monthlySummaryData: any = [];

  // ULB-wise grid
  allUlbWiseData: any = [];
  ulbWiseData: any = [];

  // ULB drilldown (filter entire dashboard to a single ULB)
  drilldownUlbName: string = "";
  drilldownTntId: number = 0;
  selectedUlbData: any = null;
  activeTabIndex: number = 0;

  // Vehicle drilldown
  showVehicleDrilldown: boolean = false;
  vehicleDrillData: any = [];
  vehicleDrillLdr: boolean = false;
  selectedUlbName: string = "";

  // AmCharts references
  private last7DaysChart: am4charts.XYChart;
  private fuelTypePieChart: am4charts.PieChart;
  private monthlyCompChart: am4charts.XYChart;

  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    private zone: NgZone,
    private router: Router
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
  }

  ngOnInit() {
    this.fromUrbanDashboard =
      this.TransfereService.getLoclData("from_urban_dashboard") === true;
    this.TransfereService.setLoclData("from_urban_dashboard", false);
    this.slctdDt = new Date();
    this.curMonth = this.slctdDt.getMonth() + 1;
    this.curYear = this.slctdDt.getFullYear();
    this.loadAllData();
  }

  goBackToDashboard() {
    this.router.navigate([`internal/dashboard/urban-dashboard`]);
  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      this.disposeCharts();
    });
  }

  onMonthChange(result: Date): void {
    if (result) {
      this.curMonth = result.getMonth() + 1;
      this.curYear = result.getFullYear();
      this.loadAllData();
    }
  }

  ontntSelect(value) {
    this.selectedtenant = value;
    this.loadAllData();
  }

  fltrs() {
    this.filters = !this.filters;
  }

  loadAllData() {
    this.loadLast7Days();
    this.loadMonthlySummary();
    this.loadMileageVariance();
    this.loadUlbWiseData();
  }

  loadFuelSummary() {
    this.showLdr = true;
    let endOfMonth = moment(this.slctdDt).endOf("month");
    let today = moment();
    let effectiveDt = endOfMonth.isAfter(today)
      ? today.format("YYYY-MM-DD")
      : endOfMonth.format("YYYY-MM-DD");
    let postData: any = {
      dt: effectiveDt,
      mnth: this.curMonth,
      yr: this.curYear,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/get_fuel_data/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        if (res["data"] && res["data"].length > 0) {
          this.fuelSummary = res["data"][0];
        } else {
          this.fuelSummary = {};
        }
        // Init pie chart after summary loads
        this.zone.runOutsideAngular(() => {
          setTimeout(() => this.initFuelTypePieChart(), 300);
        });
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
        this.fuelSummary = {};
        this.showLdr = false;
      }
    );
  }

  loadLast7Days() {
    // Show all days of the selected month (not just last 7)
    let endOfMonth = moment(this.slctdDt).endOf("month");
    let today = moment();
    let effectiveDt = endOfMonth.isAfter(today)
      ? today.format("YYYY-MM-DD")
      : endOfMonth.format("YYYY-MM-DD");
    let startOfMonth = moment(this.slctdDt).startOf("month");
    let days = moment(effectiveDt).diff(startOfMonth, "days") + 1;
    let postData: any = {
      dt: effectiveDt,
      slctd_tnt: this.selectedtenant,
      days: days,
    };
    let rte = `dashboard/enterprise/get_fuel_last7days/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.last7DaysData = res["data"] || [];
        this.zone.runOutsideAngular(() => {
          setTimeout(() => this.initLast7DaysChart(), 300);
        });
      },
      (err) => {
        console.log(err);
        this.last7DaysData = [];
      }
    );
  }

  loadMonthlySummary() {
    let postData: any = {
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/get_fuel_summary_monthly/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.monthlySummaryData = res["data"] || [];
        this.zone.runOutsideAngular(() => {
          setTimeout(() => this.initMonthlyCompChart(), 300);
        });
      },
      (err) => {
        console.log(err);
        this.monthlySummaryData = [];
      }
    );
  }

  loadMileageVariance() {
    // Use min(today, endOfMonth) so current month doesn't query future dates
    let endOfMonth = moment(this.slctdDt).endOf("month");
    let today = moment();
    let effectiveDt = endOfMonth.isAfter(today)
      ? today.format("YYYY-MM-DD")
      : endOfMonth.format("YYYY-MM-DD");
    let postData: any = {
      dt: effectiveDt,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/get_mileage_variance/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        if (res["data"] && res["data"].length > 0) {
          this.mileageVarianceCount =
            res["data"][0].mileage_variance_count || 0;
        } else {
          this.mileageVarianceCount = 0;
        }
      },
      (err) => {
        console.log(err);
        this.mileageVarianceCount = 0;
      }
    );
  }

  loadUlbWiseData() {
    this.showLdr = true;
    this.ulbWiseData = [];
    this.allUlbWiseData = [];
    this.selectedUlbCard = "";
    let postData: any = {
      mnth: this.curMonth,
      yr: this.curYear,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/get_fuel_ulb_wise/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.allUlbWiseData = res["data"] || [];
        this.ulbWiseData = [...this.allUlbWiseData];
        this.totalUlbs = this.allUlbWiseData.length;
        this.ulbsFuelEntered = this.allUlbWiseData.filter(
          (u) => (u.total_entries || 0) > 0
        ).length;
        this.ulbsFuelNotEntered = this.totalUlbs - this.ulbsFuelEntered;

        // Derive fuelSummary from ULB data — single source of truth for all counts
        this.fuelSummary = {
          total_entries: this.allUlbWiseData.reduce(
            (s, u) => s + (u.total_entries || 0),
            0
          ),
          total_lt: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.total_lt) || 0),
            0
          ),
          total_am: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.total_am) || 0),
            0
          ),
          ptrl_ct: this.allUlbWiseData.reduce(
            (s, u) => s + (u.ptrl_ct || 0),
            0
          ),
          ptrl_lt: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.ptrl_lt) || 0),
            0
          ),
          ptrl_am: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.ptrl_am) || 0),
            0
          ),
          dsl_ct: this.allUlbWiseData.reduce((s, u) => s + (u.dsl_ct || 0), 0),
          dsl_lt: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.dsl_lt) || 0),
            0
          ),
          dsl_am: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.dsl_am) || 0),
            0
          ),
          cng_ct: this.allUlbWiseData.reduce((s, u) => s + (u.cng_ct || 0), 0),
          cng_lt: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.cng_lt) || 0),
            0
          ),
          cng_am: this.allUlbWiseData.reduce(
            (s, u) => s + (parseFloat(u.cng_am) || 0),
            0
          ),
          vehicles_ct: this.allUlbWiseData.reduce(
            (s, u) => s + (u.vehicles_ct || 0),
            0
          ),
        };

        // Init pie chart after summary is computed
        this.zone.runOutsideAngular(() => {
          setTimeout(() => this.initFuelTypePieChart(), 300);
        });
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
        this.allUlbWiseData = [];
        this.ulbWiseData = [];
        this.fuelSummary = {};
        this.showLdr = false;
      }
    );
  }

  onUlbCardClick(card: string) {
    if (this.selectedUlbCard === card) {
      this.selectedUlbCard = "";
      this.ulbWiseData = [...this.allUlbWiseData];
      return;
    }
    this.selectedUlbCard = card;
    let filtered = [];
    if (card === "ulb_total") {
      filtered = [...this.allUlbWiseData];
    } else if (card === "ulb_entered") {
      filtered = this.allUlbWiseData.filter((u) => (u.total_entries || 0) > 0);
    } else if (card === "ulb_not_entered") {
      filtered = this.allUlbWiseData.filter(
        (u) => (u.total_entries || 0) === 0
      );
    }
    this.ulbWiseData = filtered.map((row, idx) => ({ ...row, sno: idx + 1 }));
    this.scrollToElement("ulbFuelGrid");
  }

  scrollToElement(id: string) {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 400);
  }

  onUlbNameClick(rowData: any) {
    if (rowData) {
      this.drilldownUlbName = rowData.tnt_dsply_nm || rowData.tnt_nm;
      this.drilldownTntId = rowData.tnt_id;
      this.selectedUlbData = rowData;
      this.selectedtenant = rowData.tnt_id;
      this.activeTabIndex = 1;
      this.loadAllData();
      this.loadVehicleDrilldown(rowData.tnt_id);
    }
  }

  goBackToAllUlbs() {
    this.drilldownUlbName = "";
    this.drilldownTntId = 0;
    this.selectedUlbData = null;
    this.selectedtenant = 0;
    this.showVehicleDrilldown = false;
    this.activeTabIndex = 0;
    this.loadAllData();
  }

  loadVehicleDrilldown(tntId: number) {
    this.showVehicleDrilldown = true;
    this.vehicleDrillLdr = true;
    this.vehicleDrillData = [];
    this.selectedUlbName = this.drilldownUlbName;

    let postData: any = {
      tnt_id: tntId,
      mnth: this.curMonth,
      yr: this.curYear,
    };
    let rte = `dashboard/enterprise/get_fuel_vehicle_wise/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.vehicleDrillData = res["data"] || [];
        this.vehicleDrillLdr = false;
      },
      (err) => {
        console.log(err);
        this.vehicleDrillData = [];
        this.vehicleDrillLdr = false;
      }
    );
  }

  // ==================== AmCharts — Modern UI/UX Redesign ====================

  initLast7DaysChart() {
    if (this.last7DaysChart) {
      this.last7DaysChart.dispose();
    }
    if (!document.getElementById("last7DaysChartDiv")) {
      return;
    }

    let chart = am4core.create("last7DaysChartDiv", am4charts.XYChart);
    chart.paddingTop = 20;
    chart.paddingRight = 25;
    chart.paddingBottom = 5;
    chart.paddingLeft = 10;

    chart.data = this.last7DaysData.map((d) => ({
      date: d.dt,
      petrol: parseFloat(d.petrol_litres) || 0,
      diesel: parseFloat(d.diesel_litres) || 0,
      cng: parseFloat(d.cng_kg) || 0,
    }));

    // Category axis — clean minimal style
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "date";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 40;
    categoryAxis.renderer.labels.template.fontSize = 11;
    categoryAxis.renderer.labels.template.fontWeight = "500";
    categoryAxis.renderer.labels.template.fill = am4core.color("#64748b");
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.line.strokeOpacity = 0.12;
    categoryAxis.renderer.line.stroke = am4core.color("#94a3b8");

    // Value axis — subtle horizontal gridlines only
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.labels.template.fill = am4core.color("#94a3b8");
    valueAxis.renderer.grid.template.strokeOpacity = 0.06;
    valueAxis.renderer.grid.template.strokeDasharray = "3,3";
    valueAxis.renderer.line.strokeOpacity = 0;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.min = 0;

    // --- Smooth curved area series for each fuel type ---
    this.createAreaSeries(chart, "petrol", "Petrol", "#f43f5e", "#fda4af");
    this.createAreaSeries(chart, "diesel", "Diesel", "#14b8a6", "#5eead4");
    this.createAreaSeries(chart, "cng", "CNG", "#0ea5e9", "#7dd3fc");

    // Legend — pill style at bottom
    chart.legend = new am4charts.Legend();
    chart.legend.fontSize = 11;
    chart.legend.fontWeight = "600";
    chart.legend.labels.template.fill = am4core.color("#475569");
    chart.legend.position = "bottom";
    chart.legend.contentAlign = "center";
    chart.legend.paddingTop = 12;
    chart.legend.markers.template.width = 10;
    chart.legend.markers.template.height = 10;
    let markerTemplate = chart.legend.markers.template.children.getIndex(
      0
    ) as any;
    if (markerTemplate) {
      markerTemplate.cornerRadius(5, 5, 5, 5);
    }

    // Cursor — crosshair style with snap
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "none";
    chart.cursor.lineX.stroke = am4core.color("#6366f1");
    chart.cursor.lineX.strokeWidth = 1;
    chart.cursor.lineX.strokeOpacity = 0.3;
    chart.cursor.lineX.strokeDasharray = "4,4";
    chart.cursor.lineY.disabled = true;
    chart.cursor.fullWidthLineX = true;
    chart.responsive.enabled = true;

    this.last7DaysChart = chart;
  }

  private createAreaSeries(
    chart: am4charts.XYChart,
    field: string,
    name: string,
    lineColor: string,
    areaColor: string
  ) {
    let series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = field;
    series.dataFields.categoryX = "date";
    series.name = name;
    series.stroke = am4core.color(lineColor);
    series.strokeWidth = 2.5;
    series.tensionX = 0.77;
    series.tensionY = 0.77;

    // Gradient area fill beneath the line
    let gradient = new am4core.LinearGradient();
    gradient.addColor(am4core.color(lineColor), 0.25);
    gradient.addColor(am4core.color(areaColor), 0.08);
    gradient.addColor(am4core.color("#ffffff"), 0);
    gradient.rotation = 90;
    series.fill = gradient;
    series.fillOpacity = 1;

    // Circle bullets at data points
    let bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.radius = 4;
    bullet.circle.fill = am4core.color("#ffffff");
    bullet.circle.stroke = am4core.color(lineColor);
    bullet.circle.strokeWidth = 2;
    bullet.circle.fillOpacity = 1;

    // Hover state — enlarge bullet
    let hoverState = bullet.states.create("hover");
    hoverState.properties.scale = 1.6;

    // Value label above bullet
    let labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.text = "{valueY}";
    labelBullet.label.fontSize = 9;
    labelBullet.label.fontWeight = "700";
    labelBullet.label.fill = am4core.color(lineColor);
    labelBullet.label.dy = -14;
    labelBullet.label.hideOversized = true;
    labelBullet.label.truncate = false;

    // Tooltip
    series.tooltipText = "[bold]{name}[/]\n{categoryX}: [bold]{valueY}[/] Lt";
    series.tooltip.label.fontSize = 12;
    series.tooltip.background.cornerRadius = 8;
    series.tooltip.background.fillOpacity = 0.95;
    series.tooltip.background.fill = am4core.color(lineColor);
    series.tooltip.label.fill = am4core.color("#ffffff");
    series.tooltip.background.strokeWidth = 0;
    series.tooltip.pointerOrientation = "vertical";

    series.sequencedInterpolation = true;
  }

  initFuelTypePieChart() {
    if (this.fuelTypePieChart) {
      this.fuelTypePieChart.dispose();
    }
    if (!document.getElementById("fuelTypePieChartDiv")) {
      return;
    }

    let chart = am4core.create("fuelTypePieChartDiv", am4charts.PieChart);

    let ptrl = parseFloat(this.fuelSummary?.ptrl_lt) || 0;
    let dsl = parseFloat(this.fuelSummary?.dsl_lt) || 0;
    let cng = parseFloat(this.fuelSummary?.cng_lt) || 0;
    let totalLt = ptrl + dsl + cng;

    chart.data = [
      { type: "Petrol", litres: ptrl, color: am4core.color("#f43f5e") },
      { type: "Diesel", litres: dsl, color: am4core.color("#14b8a6") },
      { type: "CNG", litres: cng, color: am4core.color("#0ea5e9") },
    ];

    // Donut with wider inner radius
    chart.innerRadius = am4core.percent(55);
    chart.radius = am4core.percent(85);

    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "type";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.slices.template.stroke = am4core.color("#ffffff");
    pieSeries.slices.template.strokeWidth = 4;
    pieSeries.slices.template.strokeOpacity = 1;
    pieSeries.slices.template.fillOpacity = 0.92;
    pieSeries.slices.template.cornerRadius = 8;

    // Disable outer labels — use legend instead for cleaner look
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;

    // Tooltip — colored per slice
    pieSeries.slices.template.tooltipText =
      '[bold]{category}[/]\n{value} Lt ({value.percent.formatNumber("#.0")}%)';
    pieSeries.tooltip.label.fontSize = 12;
    pieSeries.tooltip.background.cornerRadius = 8;
    pieSeries.tooltip.background.fillOpacity = 0.96;
    pieSeries.tooltip.background.strokeWidth = 0;

    // Hover effect — scale up
    let hoverState = pieSeries.slices.template.states.getKey("hover");
    hoverState.properties.scale = 1.08;
    hoverState.properties.fillOpacity = 1;

    // Active state
    let activeState = pieSeries.slices.template.states.getKey("active");
    activeState.properties.shiftRadius = 0;

    // Center label — Total Litres
    let centerLabel = chart.seriesContainer.createChild(am4core.Label);
    centerLabel.text = totalLt > 0 ? this.formatNumber(totalLt) : "0";
    centerLabel.horizontalCenter = "middle";
    centerLabel.verticalCenter = "middle";
    centerLabel.fontSize = 22;
    centerLabel.fontWeight = "800";
    centerLabel.fill = am4core.color("#1e293b");
    centerLabel.dy = -6;

    let centerSubLabel = chart.seriesContainer.createChild(am4core.Label);
    centerSubLabel.text = "Total Litres";
    centerSubLabel.horizontalCenter = "middle";
    centerSubLabel.verticalCenter = "middle";
    centerSubLabel.fontSize = 10;
    centerSubLabel.fontWeight = "600";
    centerSubLabel.fill = am4core.color("#94a3b8");
    centerSubLabel.dy = 14;
    (centerSubLabel as any).textTransform = "uppercase";

    // Legend — horizontal at bottom with percent
    chart.legend = new am4charts.Legend();
    chart.legend.fontSize = 11;
    chart.legend.fontWeight = "600";
    chart.legend.position = "bottom";
    chart.legend.contentAlign = "center";
    chart.legend.paddingTop = 8;
    chart.legend.labels.template.fill = am4core.color("#475569");
    chart.legend.markers.template.width = 10;
    chart.legend.markers.template.height = 10;
    let pieMarker = chart.legend.markers.template.children.getIndex(0) as any;
    if (pieMarker) {
      pieMarker.cornerRadius(5, 5, 5, 5);
    }
    chart.legend.valueLabels.template.text =
      '{value.percent.formatNumber("#.0")}%';
    chart.legend.valueLabels.template.fill = am4core.color("#64748b");
    chart.legend.valueLabels.template.fontSize = 11;
    chart.legend.valueLabels.template.fontWeight = "700";

    chart.responsive.enabled = true;

    this.fuelTypePieChart = chart;
  }

  private formatNumber(num: number): string {
    if (num >= 100000) {
      return (num / 1000).toFixed(0) + "K";
    } else if (num >= 10000) {
      return (num / 1000).toFixed(1) + "K";
    }
    return num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  initMonthlyCompChart() {
    if (this.monthlyCompChart) {
      this.monthlyCompChart.dispose();
    }
    if (!document.getElementById("monthlyCompChartDiv")) {
      return;
    }

    let chart = am4core.create("monthlyCompChartDiv", am4charts.XYChart);
    chart.paddingTop = 20;
    chart.paddingRight = 25;
    chart.paddingBottom = 5;

    if (this.monthlySummaryData && this.monthlySummaryData.length >= 2) {
      const current = this.monthlySummaryData[0];
      const previous = this.monthlySummaryData[1];

      // Build data with percentage change
      let buildItem = (fuel: string, curVal: number, prevVal: number) => {
        let pctChange = prevVal > 0 ? ((curVal - prevVal) / prevVal) * 100 : 0;
        return {
          fuel,
          current: curVal,
          previous: prevVal,
          pctChange: Math.round(pctChange),
        };
      };

      chart.data = [
        buildItem(
          "Petrol",
          parseFloat(current.petrol_litres) || 0,
          parseFloat(previous.petrol_litres) || 0
        ),
        buildItem(
          "Diesel",
          parseFloat(current.diesel_litres) || 0,
          parseFloat(previous.diesel_litres) || 0
        ),
        buildItem(
          "CNG",
          parseFloat(current.cng_kg) || 0,
          parseFloat(previous.cng_kg) || 0
        ),
        buildItem(
          "Total",
          parseFloat(current.total_litres) || 0,
          parseFloat(previous.total_litres) || 0
        ),
      ];

      // Category axis — clean
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "fuel";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 1;
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fontWeight = "700";
      categoryAxis.renderer.labels.template.fill = am4core.color("#475569");
      categoryAxis.renderer.grid.template.strokeOpacity = 0;
      categoryAxis.renderer.line.strokeOpacity = 0.12;
      categoryAxis.renderer.cellStartLocation = 0.12;
      categoryAxis.renderer.cellEndLocation = 0.88;

      // Value axis — subtle gridlines
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 10;
      valueAxis.renderer.labels.template.fill = am4core.color("#94a3b8");
      valueAxis.renderer.grid.template.strokeOpacity = 0.06;
      valueAxis.renderer.grid.template.strokeDasharray = "3,3";
      valueAxis.renderer.line.strokeOpacity = 0;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.min = 0;
      valueAxis.extraMax = 0.15;

      // --- Current Month Series --- (gradient fill)
      let currentSeries = chart.series.push(new am4charts.ColumnSeries());
      currentSeries.dataFields.valueY = "current";
      currentSeries.dataFields.categoryX = "fuel";
      currentSeries.name = current.month_label || "Current Month";
      currentSeries.columns.template.width = am4core.percent(80);
      currentSeries.columns.template.column.cornerRadiusTopLeft = 6;
      currentSeries.columns.template.column.cornerRadiusTopRight = 6;
      currentSeries.columns.template.strokeWidth = 0;
      currentSeries.sequencedInterpolation = true;

      // Gradient fill for current month
      let curGradient = new am4core.LinearGradient();
      curGradient.addColor(am4core.color("#818cf8"), 1);
      curGradient.addColor(am4core.color("#6366f1"), 1);
      curGradient.addColor(am4core.color("#4f46e5"), 1);
      curGradient.rotation = 90;
      currentSeries.columns.template.fill = curGradient;
      currentSeries.columns.template.fillOpacity = 0.92;

      // Tooltip
      currentSeries.columns.template.tooltipText =
        "[bold]{name}[/]\n{categoryX}: [bold]{valueY}[/] Lt";
      currentSeries.tooltip.label.fontSize = 12;
      currentSeries.tooltip.background.cornerRadius = 8;
      currentSeries.tooltip.background.fill = am4core.color("#6366f1");
      currentSeries.tooltip.label.fill = am4core.color("#ffffff");
      currentSeries.tooltip.background.strokeWidth = 0;
      currentSeries.tooltip.pointerOrientation = "vertical";

      // Percentage change label above current bars
      let currentLabel = currentSeries.bullets.push(
        new am4charts.LabelBullet()
      );
      currentLabel.label.text = "{valueY}";
      currentLabel.label.fontSize = 9;
      currentLabel.label.fontWeight = "700";
      currentLabel.label.fill = am4core.color("#4f46e5");
      currentLabel.label.dy = -10;
      currentLabel.label.truncate = false;
      currentLabel.label.hideOversized = false;

      // Hover state
      let curHover =
        currentSeries.columns.template.column.states.create("hover");
      curHover.properties.fillOpacity = 1;

      // --- Previous Month Series --- (lighter, muted)
      let previousSeries = chart.series.push(new am4charts.ColumnSeries());
      previousSeries.dataFields.valueY = "previous";
      previousSeries.dataFields.categoryX = "fuel";
      previousSeries.name = previous.month_label || "Previous Month";
      previousSeries.columns.template.width = am4core.percent(80);
      previousSeries.columns.template.column.cornerRadiusTopLeft = 6;
      previousSeries.columns.template.column.cornerRadiusTopRight = 6;
      previousSeries.columns.template.strokeWidth = 0;
      previousSeries.sequencedInterpolation = true;

      // Soft gradient for previous month
      let prevGradient = new am4core.LinearGradient();
      prevGradient.addColor(am4core.color("#fcd34d"), 1);
      prevGradient.addColor(am4core.color("#f3aa4d"), 1);
      prevGradient.rotation = 90;
      previousSeries.columns.template.fill = prevGradient;
      previousSeries.columns.template.fillOpacity = 0.85;

      // Tooltip
      previousSeries.columns.template.tooltipText =
        "[bold]{name}[/]\n{categoryX}: [bold]{valueY}[/] Lt";
      previousSeries.tooltip.label.fontSize = 12;
      previousSeries.tooltip.background.cornerRadius = 8;
      previousSeries.tooltip.background.fill = am4core.color("#f3aa4d");
      previousSeries.tooltip.label.fill = am4core.color("#ffffff");
      previousSeries.tooltip.background.strokeWidth = 0;
      previousSeries.tooltip.pointerOrientation = "vertical";

      // Value label above previous bars
      let prevLabel = previousSeries.bullets.push(new am4charts.LabelBullet());
      prevLabel.label.text = "{valueY}";
      prevLabel.label.fontSize = 9;
      prevLabel.label.fontWeight = "600";
      prevLabel.label.fill = am4core.color("#d97706");
      prevLabel.label.dy = -10;
      prevLabel.label.truncate = false;
      prevLabel.label.hideOversized = false;

      // Hover state
      let prevHover =
        previousSeries.columns.template.column.states.create("hover");
      prevHover.properties.fillOpacity = 0.85;

      // Legend — pill markers
      chart.legend = new am4charts.Legend();
      chart.legend.fontSize = 11;
      chart.legend.fontWeight = "600";
      chart.legend.labels.template.fill = am4core.color("#475569");
      chart.legend.position = "bottom";
      chart.legend.contentAlign = "center";
      chart.legend.paddingTop = 12;
      chart.legend.markers.template.width = 10;
      chart.legend.markers.template.height = 10;
      let compMarker = chart.legend.markers.template.children.getIndex(
        0
      ) as any;
      if (compMarker) {
        compMarker.cornerRadius(5, 5, 5, 5);
      }

      // Cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.behavior = "none";
      chart.cursor.lineX.stroke = am4core.color("#6366f1");
      chart.cursor.lineX.strokeWidth = 1;
      chart.cursor.lineX.strokeOpacity = 0.2;
      chart.cursor.lineX.strokeDasharray = "4,4";
      chart.cursor.lineY.disabled = true;
      chart.responsive.enabled = true;
    }

    this.monthlyCompChart = chart;
  }

  disposeCharts() {
    if (this.last7DaysChart) {
      this.last7DaysChart.dispose();
    }
    if (this.fuelTypePieChart) {
      this.fuelTypePieChart.dispose();
    }
    if (this.monthlyCompChart) {
      this.monthlyCompChart.dispose();
    }
  }
}
